import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import Cluster from '../Support/Cluster';
import Header from '../Blocks/Header';
import LoginForm from '../Blocks/LoginForm';
import SearchForm from '../Blocks/SearchForm';

const dashboard = (props) => {

	let content = (
		<section className='page__section page__section--white'>
			<div className='wrapper clearfix'>
				<div className='page__content page__content--full'>
					<h3 className='page__heading page__heading--centre'>Dashboard</h3>
				</div>
				<LoginForm flair='middled' />
			</div>
		</section>
	);

	if(props.user !== null) {
		content = (
			<div className='dashboard page'>

				<section className='page__section page__section--grey'>
					<div className='wrapper wrapper--tiny'>

						<div className='page__content page__content--full'>

							<h4 className='page__section__heading page__section__heading--centre page__section__heading--push-top'>Enter your matter ID below</h4>

							<SearchForm token={props.token} />

						</div>

					</div>
				</section>

				<section className='page__section page__section--white'>
					<div className='wrapper wrapper--tiny'>

						<div className='page__content page__content--priority page__content--centre page__content--full'>

							<p><NavLink to='/matter/new/' className='btn btn--grey btn--stubborn'>New matter</NavLink></p>

							<p>You need a Matter ID to start a session.<br />Select the 'New Matter' button to create a unique identifier for your matter. Record this Matter ID in your file notes IMMEDIATELY.<br />If at any point in the future you want to return to the information in this session, you must at that time enter the original Matter ID from the first session.</p>

						</div>

					</div>
				</section>

			</div>
		);
	}

	return (
		<Cluster>
			<Header />
			{content}
		</Cluster>
	);

}

const mapStateToProps = state => {
	return {
		user: state.user,
		token: state.token
	};
}


export default connect(mapStateToProps)(dashboard);


// WEBPACK FOOTER //
// ./src/Pages/Dashboard.js